import './App.css';
import Layout from "./components/Layout";
import React from 'react';
import store from './stores/Store'
import { Provider } from 'react-redux';


function App({ Component, pageProps }) {
  console.log('---process-env:', process.env);

  return (
    <div className="App">
      <Provider store={store}>
        <Layout>
          {/* <Component {...pageProps} /> */}
        </Layout>
      </Provider>
    </div>
  );
}

export default App;
